import { Skeleton } from '@innovamat/glimmer-components';

import { JourneyGrid, ListContainer } from '../../school-journeys';

const ClassCardSkeleton = (): JSX.Element => (
  <Skeleton width="100%" height="126" radius="8" />
);

function SchoolJourneysSkeleton(): JSX.Element {
  const renderClassCardSkeletons = (count: number): JSX.Element[] =>
    Array.from({ length: count }, (_, index) => (
      <ClassCardSkeleton key={index} />
    ));

  return (
    <ListContainer>
      <JourneyGrid>{renderClassCardSkeletons(6)}</JourneyGrid>
    </ListContainer>
  );
}

export { SchoolJourneysSkeleton };
